import {Inject, Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import {WindowProvider} from "../providers/window.provider";

interface PreviewMetaFile extends File {
  __wtgPreviewMeta?: {
    previewUrl?: string;
  };
}

@Pipe({
  name: 'sanitizeUrl'
})
export class SanitizeUrlPipe implements PipeTransform {

  constructor(
    @Inject(WindowProvider) private window: any,
    private sanitizer: DomSanitizer
  ) {
  }

  transform(v: any): SafeUrl {
    if (v instanceof File) {
      const previewUrl = (v as PreviewMetaFile).__wtgPreviewMeta?.previewUrl;
      if (previewUrl) {
        return this.sanitizer.bypassSecurityTrustUrl(previewUrl);
      }

      return this.sanitizer.bypassSecurityTrustUrl(this.window.URL.createObjectURL(v));
    }

    return null;
  }
}
